import { Component, ChangeDetectionStrategy, DOCUMENT, inject, OnInit } from '@angular/core';
import { LayoutModule } from '../layout-module';
import { LocalizationService } from '../../../Services/localization-service';

@Component({
  selector: 'app-home-component',
  imports: [LayoutModule],
  templateUrl: './home-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './home-component.scss'
})
export class HomeComponent implements OnInit {
  private readonly localizationService = inject(LocalizationService);
  private readonly document = inject(DOCUMENT);

  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe((lang) => {
      const normalizedLang = lang || 'en-US';
      const canonicalUrl = `${this.document.location.origin}/${normalizedLang}/home`;
      this.updateCanonicalUrl(canonicalUrl);
    });
  }

  private updateCanonicalUrl(canonicalUrl: string): void {
    let link = this.document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }

    link.setAttribute('href', canonicalUrl);
  }
}
